import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=4f4d1fec&scoped=true"
import script from "./Requests.vue?vue&type=script&lang=js"
export * from "./Requests.vue?vue&type=script&lang=js"
import style0 from "./Requests.vue?vue&type=style&index=0&id=4f4d1fec&prod&lang=scss&scoped=true"
import style1 from "./Requests.vue?vue&type=style&index=1&id=4f4d1fec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d1fec",
  null
  
)

export default component.exports